import React from "react";
import {useTranslation} from "react-i18next";

// CSS Files
import "./styles.css";

const RankingTable = (props) => {
   const { t } = useTranslation();

   return <div className={"RankingTable"}>
      <div className={"table-container"}>
         <div className={"ranks"}>
            <div className={"rank-header"}>
               <p>{t("ranking_page.rank")}</p>
            </div>
            {props.ranking?.map(rank => {
               return <div key={rank.id} className={"player"}>
                  <p className={"rank"}>{rank.ranking}</p>
                  <div className={"player-info"}>
                     <img src={rank.player.photo_url}/>
                     <p>{rank.player.shortname}</p>
                  </div>
               </div>
            })}
         </div>

         <div className={"scores"}>
            <table className={"table"}>
               <thead>
               <tr>
                  <th>{t("ranking_page.matches")}</th>
                  <th className={"points"}>{t("ranking_page.points")}</th>
                  <th>{t("ranking_page.victories")}</th>
                  <th>{t("ranking_page.defeats")}</th>
                  <th>{t("ranking_page.games_won")}</th>
                  <th>{t("ranking_page.games_lost")}</th>
                  <th>{t("ranking_page.games_difference")}</th>
               </tr>
               </thead>

               <tbody>
               {props.ranking?.map(rank => {
                  return <tr key={rank.id}>
                     <td className={"matches"}>{rank.matches}</td>
                     <td className={"points"}>{rank.points}</td>
                     <td>{rank.victories}</td>
                     <td>{rank.defeats}</td>
                     <td>{rank.matches_won}</td>
                     <td>{rank.matches_defeated}</td>
                     <td>{rank.difference}</td>
                  </tr>
               })}
               </tbody>
            </table>
         </div>
      </div>
   </div>
}

export default RankingTable;
